import * as Sentry from "@sentry/browser";

import { hasOwnProperty } from "~/lib/js";

export const addBreadcrumb = (args: { category: string; message: string; level: Sentry.SeverityLevel }) => {
	if (window.SENTRY_DSN_PUBLIC) {
		Sentry.addBreadcrumb({
			category: args.category,
			message: args.message,
			level: args.level,
		});
	}
};

function isArray(value: unknown): value is unknown[] {
	return Array.isArray(value);
}

export function getFirstUserFacingError(errors: unknown): string | null {
	let iterErrors;

	// this first if statement captures errors that come from catching exceptions using the commitMutationPromise
	// onError callback since they are rejected before onComplete is run, meaning the error isn't split up the same way
	// that they are in onComplete. The errors in this object are under the e.source.errors value in the error
	// parameter e that the onError callback uses. This checks if the input value `errors` in this function is this
	// object and the error array that we can find the userFacingMessage from ex: /lib/desktopTrayApi/meetingRecorder.ts
	if (
		typeof errors === "object" &&
		errors !== null &&
		hasOwnProperty(errors, "source") &&
		typeof errors.source === "object" &&
		errors.source !== null &&
		hasOwnProperty(errors.source, "errors") &&
		isArray(errors.source.errors)
	) {
		iterErrors = errors.source.errors;
	} else if (!isArray(errors)) {
		iterErrors = [errors];
	} else {
		iterErrors = errors;
	}

	for (const error of iterErrors) {
		if (typeof error !== "object" || error === null) continue;
		if (hasOwnProperty(error, "userFacingMessage") && typeof error.userFacingMessage === "string") {
			return error.userFacingMessage;
		}
	}

	return null;
}
